import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useCommerceAPI} from '../../commerce-api/contexts'
import StyledContent from '../styled-content'
import {Stack, Skeleton, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import useAsync from '../../commerce-api/hooks/useAsync'

const ContentAsset = ({id, ...props}) => {
    const api = useCommerceAPI()
    const {formatMessage} = useIntl()
    const {execute, data, error, loading} = useAsync((id) =>
        api.shopperContent.getContent({
            parameters: {cid: id, html: true}
        })
    )

    useEffect(() => {
        execute(id)
    }, [execute, id])

    if (loading) {
        return (
            <Stack data-testid="content-asset-loading-skeleton">
                <Skeleton height="20px" />
                <Skeleton height="20px" />
                <Skeleton height="20px" />
            </Stack>
        )
    }

    if (error || !data?.c_body) {
        return (
            <Text data-testid="content-asset-error">
                {formatMessage({
                    id: 'global.error.something_went_wrong',
                    defaultMessage: 'Hmmm! Something went wrong. Please try again.'
                })}
            </Text>
        )
    }

    return <StyledContent content={data?.c_body || ''} {...props} />
}

ContentAsset.propTypes = {
    id: PropTypes.string
}

export default ContentAsset
